import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";
import ExportMenu from "../../../components/shared/ExportMenu";

const Exports = ({ supplier, retailer, hideDiscontinued = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const fetchCsv = async (vars, url, name) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(vars),
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, requestOptions);
      setIsLoading(false);

      const contentType = response.headers.get("content-type");
      console.log("contentType: ", contentType);
      if (contentType && (contentType.includes("text/csv") || contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${name}_${vars.supplier}_${vars.retailer}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          title: "Success",
          description: `${name} file downloaded successfully.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        console.log("error", response);
        toast({
          title: "Error",
          description: "An error occurred while downloading the file.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoading(false);
      toast({
        title: "Technical Error",
        description: "A technical error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleRangingClick = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/rep_ranging/csv-rangingReport`;
      const name = "Ranging Report";
      // The sheet mirrors what is on screen, so the toggle rides along and
      // the backend drops the same article columns.
      const vars = { supplier, retailer, userid: 1, hideDiscontinued };
      await fetchCsv(vars, url, name);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  return <ExportMenu isLoading={isLoading} items={[{ label: "Ranging Report", onClick: handleRangingClick }]} />;
};

export default Exports;
